<!-- //
详情页面
@auth xuyd
@date 2023-3-1
//-->
<template>
	<div class="site-container">
		<el-tabs v-model="activeName">
			<el-tab-pane v-for="(item, index) in $store.getters.dictType['ENV_TYPE']" :label="item.label" :name="item.value" :key="index">
				<SiteList ref="refForm" :config-data="siteConfigMap[item.value]" @reload="handleReload" @edit="handleModify" />
			</el-tab-pane>
		</el-tabs>
		<div class="tab-bar">
			<div class="flex-row flex-valign-center">
				<el-tag size="small" type="primary">{{ siteData.terminalLabel }}</el-tag>
				<el-divider direction="vertical" />
				<span class="ml10">站点名：</span>
				<dict-tag class="ml5" :dictType="siteData.terminalType" :value="siteData.terminalSite" />
				<el-divider direction="vertical" />
				<span class="ml10">默认站点：</span>
          <el-switch v-model="siteData.defaultSite" :active-value="1" :inactive-value="0" @change="handleUpdateSite" :disabled="!hasPermission" />
				<el-divider direction="vertical" />
				<div style="margin-left: 20px">
					<el-button size="small" type="primary" @click="handleAddConfigClick" v-permission="['sys:multiEnvConfig:add']">添加参数</el-button>
				</div>
			</div>
		</div>
		<SiteAdd ref="refSiteAdd" />
	</div>
</template>

<script>
import MultiEnvApi from "@/api/sys/sysMultiEnv.api";
import SiteList from "./site-list.vue";
import SiteAdd from "./site-add.vue";

export default {
	name: "ViewTerminalSite",
	components: { SiteList, SiteAdd },
	dictTypes: [
    {dictType: 'ENV_TYPE', dataType: String},              // 环境(develop,production)
    {dictType: 'TERMINAL_SITE_TYPE', dataType: String},     // 站点类型
    {dictType: 'TERMINAL_SITE_AREA', dataType: String},     // 站点(shanghai, hangzhou)
    {dictType: 'TERMINAL_SITE_PROD', dataType: String},     // 站点(prod)
    {dictType: 'TERMINAL_SITE_FZ_PROD', dataType: String},  // 站点(fz,prod)
    {dictType: 'TERMINAL_SITE_MAIN', dataType: String},     // 站点-主
    {dictType: 'TERMINAL_SITE_MAIN_BAK', dataType: String}, // 站点-主备
	],
	data() {
		return {
			activeName: this.$store.getters.dictType["ENV_TYPE"][0].value,
			siteConfigMap: {},
		};
	},
	props: {
		siteData: {
			type: Object,
			default: () => {
				return {};
			},
		},
		index: {
			// 数组下标
			type: Number,
		},
    permission: {// 权限
      type: Array,
      default: () => {
        return ['sys:multiEnvConfig:update']
      }
    }
	},
  computed: {
    hasPermission() {
      let permissions = this.$store.getters.permissions;
      let ps = ['*:*:*',...this.permission];
      return permissions.some(permission => {
        return ps.includes(permission)
      });
    }
  },
	watch: {
		siteData: {
			handler(newVal) {
				// console.log("-----newVal----->", JSON.stringify(newVal))
				this.handleSearchDetail(newVal);
			},
			immediate: true,
		},
	},
	methods: {
		/**
		 * 查询参数
		 */
		handleSearchDetail({ terminalCode, terminalSite }) {
			if (!terminalCode || !terminalSite) return;
			MultiEnvApi.searchSiteDetailList(terminalCode, terminalSite).then((resp) => {
				this.siteConfigMap = resp.data;
			});
		},

		handleReload() {
			MultiEnvApi.searchSiteDetailList(this.siteData.terminalCode, this.siteData.terminalSite).then((resp) => {
				this.siteConfigMap = resp.data;
			});
		},

		/** 修改操作 */
		handleModify(data) {
			this.$refs.refSiteAdd.showModal({
				title: "修改参数",
				data: { ...data },
				onOk: (data) => {
					this.handleSearchDetail(this.siteData);
				},
			});
		},

		/**
		 * 修改默认站点
		 */
		handleUpdateSite() {
			MultiEnvApi.updateDefaultSite(this.siteData.id).then((resp) => {
				this.$emit("reload");
			});
		},

		/**
		 * 添加参数
		 */
		handleAddConfigClick() {
			this.$refs.refSiteAdd.showModal({
				title: "添加参数",
				data: {
					terminalCode: this.siteData.terminalCode,
					terminalLabel: this.siteData.terminalLabel,
					terminalType: this.siteData.terminalType,
					terminalSite: this.siteData.terminalSite,
					envType: this.activeName,
				},
				onOk: (data) => {
					this.handleSearchDetail(this.siteData);
				},
			});
		},
	},
};
</script>

<style lang="less" scoped>
.site-container {
	background-color: #ffffff;
	box-sizing: border-box;
	position: relative;

	.tab-bar {
		position: absolute;
		top: 8px;
		right: 30px;
	}

	:deep(.el-tabs) {
		//height: 100%;
	}

	:deep(.el-tabs__header) {
		padding-left: 10px;
		padding-right: 10px;
	}

	:deep(.el-tabs__content) {
		//height: calc(100% - 40px - 15px);
	}
}
</style>
